import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=6d45ae0f&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=6d45ae0f&prod&lang=css&scoped=true"
import style1 from "./Detail.vue?vue&type=style&index=1&id=6d45ae0f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d45ae0f",
  null
  
)

export default component.exports